<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-row>
						<el-col :span="24">
							<button class="selectAll" @click="update('add')" style="margin: 0 0 30px 0;">添加表单</button>
							<el-table   
                            :default-sort = "{prop: 'id',prop:'order', order: 'descending'}" 
                            v-loading="loading" element-loading-text="拼命加载中" 
                            element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(0, 0, 0, 0.8)" 
                            size="mini" 
                            ref="multipleTable" 
                            :data="tableData" 
                            style="width: 100%"
							border 
                            :header-cell-style="{background:'#E5E7EE',color:'#000000'}" 
                            row-key="id"  
                            :tree-props="{children: 'childRpColum', hasChildren: 'hasChildren'}"
							 @select-all="selectAll"   >
								<!-- 	<el-table-column type="selection" width="55" align="center">
								</el-table-column> -->
								<el-table-column prop="id" label="编号" align="center "  sortable>
								</el-table-column>
								<!-- <el-table-column prop="order" label="排序" align="center" sortable>
								</el-table-column> -->
								<el-table-column prop="formName" label="表单名称" align="center">
								</el-table-column>
                                <el-table-column prop="formTitle" label="表单标题" align="center">
								</el-table-column>
                                <el-table-column prop="formSubTitle" label="表单副标题" align="center">
								</el-table-column>
								<el-table-column prop="formImage" label="表单背景图" align="center">
									<template slot-scope="scope">
										<div class="demo-image__preview" @click="preview(scope.row)">
											<img style="width: 80px; height: 80px"
												:src="settings.apiBaseImg+scope.row.formImage">
										</div>
									</template>
								</el-table-column>
								<el-table-column fixed="right" label="更多操作">
									<template slot-scope="scope">
										<el-button type="success" icon="el-icon-plus" circle  size="small" class="addColumn"   @click="add(scope.row.id)"></el-button>
										<el-button type="success" icon="el-icon-edit" circle  size="small"  @click.native.prevent="update('update',scope.row)"></el-button>
										<el-button type="danger" icon="el-icon-delete" circle  @click.native.prevent="deleteRow(scope.$index,scope.row)"  size="small"></el-button>
										<el-button type="primary" icon="el-icon-info" circle  @click.native.prevent="desList(scope.row.id)"  size="small"></el-button>
									</template>
								</el-table-column>
							</el-table>
							
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
		<fox-preview-image v-model="visiable" :src="srcList" z-index="9000"></fox-preview-image>
       
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	export default {
		data() {
			return {
                // 树形控件
                props: {
                label: 'name',
                children: 'zones'
                },
                count: 1,
                isTree: false,
				form: {
					one: '',
					two: '',
					three: '',
				},
				formDialog: {
					cid: '',
					formName: '',
					formTitle: '',
					formSubTitle: '',
                    formImage:'',
				},
				rules:{
					name:[
						{required:true,message:'请输入栏目名称',tigger:'blur'}
					]
				},
				Setypes: false,
				selectType: false,
				title: '添加表单',
				tableData: [],
				currentPage: 1,
				pageSize: 5,
				total: 0,
				isAllSelect: false,
				dialogVisible: false,
				types: '',
				addType: '',
				columnId: '',
				typesId: '',
				loading: false,
				srcList: '',
				visiable: false,
			}
		},
		created() {
			this.getData()
		},
		methods: {
			//获取列表数据
			getData() {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: '/api/v1/form/page',
					params: {
						currentPage: 1,
						pageSize: 5,
						 
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						this.tableData = res.data.data.data
                        console.log(res,'表单列表')
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			// 查看图片
			preview(rows) {
				this.visiable = true
				this.srcList = ''
				this.srcList = this.settings.apiBaseImg + rows.formImage
			},
			//修改/添加
			update(iden, rows) {
				this.$router.push({
					path: '/home/formAdd',
					query: {
						rows: rows,
						iden: iden
					}
				})
			},
			// 增加详情列表
			desList(iden){
				this.$router.push({
					path: '/home/desAdd',
					query: {
						iden: iden,
					}
				})
			},
			// 增加数据项
			add(rows) {
				this.$router.push({
					path: '/home/dataAdd',
					query: {
						id: rows,
					}
				})
			},
			deleteRow(index, rows) {
				console.log(index)
				console.log(rows)
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: '/api/v1/form/delete/'+rows.id,
					}).then((res) => {
						if (res.data.status == 500) {
							obj.$message.error('请先删除子栏目')
							return;
						}
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData()
						} else {
							obj.$message.error(res.data.message)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			// 全选/取消选操作
			selectAll(selection, first) {
				if (!first) {
					this.isAllSelect = !this.isAllSelect;
				}
				selection.map(el => {
					if (el.children) {
						el.children.map(j => {
							this.toggleSelection(j, this.isAllSelect);
						});
						if (el.children.length > 0) {
							this.selectAll(el.children, true);
						}
					}
				});
			},
			handleClose(done) {
				done();
			},
            
	    },
    }
</script>

<style scoped="scoped">
	.selectAll{
		float: none;
	}
	/deep/ .el-input__inner {
		height: 40px !important;
	}

	/deep/ .el-form-item__label {
        width:250px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}

	/deep/ .el-button--text {
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	span ,/deep/ .el-table .cell{
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 24px;
	}

	.chenggong {
		width: 49px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.7;
	}

	.fail {
		width: 33px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #76B67E;
		line-height: 24px;
	}

	/deep/ .el-message {
		z-index: 9999999999999;
	}
	/deep/ .el-table__row--level-0,/deep/ .expanded{
		/* background-color: #fdf5e6; */
	}
	/deep/ .el-table__row--level-1{
		background-color:#f0f9eb;
	}
/deep/ .el-table__row--level-2{
		background-color:#fdf5e6;
	}
	.addColumn{
	background-color: #7C96F8;
	color: #FFFFFF;
	border: 1px solid #7C96F8;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/form/formManage.vue